/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Newsletter_TitleInputs */

const en_directory_home_newsletter_title = /** @type {(inputs: Directory_Home_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the best AI tools in your inbox`)
};

const zh_directory_home_newsletter_title = /** @type {(inputs: Directory_Home_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把最好的 AI 工具订阅到邮箱`)
};

/**
* | output |
* | --- |
* | "Get the best AI tools in your inbox" |
*
* @param {Directory_Home_Newsletter_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_newsletter_title = /** @type {((inputs?: Directory_Home_Newsletter_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Newsletter_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_newsletter_title(inputs)
	return zh_directory_home_newsletter_title(inputs)
});
export { directory_home_newsletter_title as "directory.home.newsletter_title" }